(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mini-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rimthin-mini-cart-controller')) {
    customElements.define('rimthin-mini-cart-controller', class extends HTMLElement {
      connectedCallback() {
        this.activeFitmentHolder = null;
        this.fitmentRuns = new WeakMap();
        this.fitmentQueue = Promise.resolve();
        this.noteTimer = null;
        this.lineUpdateTimers = new Map();
        this.drawerWasOpen = false;
        this.pageScrollX = window.scrollX;
        this.pageScrollY = window.scrollY;
        this.drawerRestoreTimer = null;
        this.onClick = this.onClick.bind(this);
        this.onQuantityClick = this.onQuantityClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onInput = this.onInput.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.refreshFitment = this.refreshFitment.bind(this);
        this.onSettingsLoad = () => requestAnimationFrame(() => this.applyEditorSettings());
        this.onDocumentReady = () => this.applyEditorSettings();
        this.onStorage = event => {
          if (!event.key || event.key.startsWith('rimthin-cart-fitment-vehicle-')) {
            this.hydrateFitmentResults();
            this.refreshFitment();
          }
        };
        this.alignDrawerToViewport = this.alignDrawerToViewport.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('click', this.onQuantityClick, true);
        this.addEventListener('change', this.onChange, true);
        this.addEventListener('input', this.onInput);
        this.addEventListener('keydown', this.onKeydown, true);
        this.fitmentEvents = ['easysearch_ready', 'easysearch_tree_inited', 'easysearch_fitment_rendered', 'easysearch_params_saved'];
        this.fitmentEvents.forEach(name => document.addEventListener(name, this.refreshFitment));
        document.addEventListener('shopify:section:load', this.onSettingsLoad);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.onDocumentReady, { once: true });
        }
        window.addEventListener('storage', this.onStorage);
        window.addEventListener('resize', this.alignDrawerToViewport, { passive: true });
        this.modal = this.closest('header-mini-cart-dropdown-modal');
        this.modalObserver = new MutationObserver(() => this.syncOpenState());
        if (this.modal) this.modalObserver.observe(this.modal, { attributes: true, attributeFilter: ['open'] });
        this.contentRoot = this.querySelector('#header-mini-cart-content');
        this.contentObserver = new MutationObserver(() => {
          this.applyEditorSettings();
          this.hydrateFitmentResults();
          requestAnimationFrame(() => {
            this.refreshFitment();
            this.scheduleFitmentRefresh();
          });
        });
        if (this.contentRoot) this.contentObserver.observe(this.contentRoot, { childList: true });
        this.applyEditorSettings();
        this.syncOpenState();
        this.hydrateFitmentResults();
        this.refreshFitment();
        this.scheduleFitmentRefresh();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('click', this.onQuantityClick, true);
        this.removeEventListener('change', this.onChange, true);
        this.removeEventListener('input', this.onInput);
        this.removeEventListener('keydown', this.onKeydown, true);
        this.fitmentEvents?.forEach(name => document.removeEventListener(name, this.refreshFitment));
        document.removeEventListener('shopify:section:load', this.onSettingsLoad);
        document.removeEventListener('DOMContentLoaded', this.onDocumentReady);
        window.removeEventListener('storage', this.onStorage);
        window.removeEventListener('resize', this.alignDrawerToViewport);
        this.modalObserver?.disconnect();
        this.contentObserver?.disconnect();
        clearTimeout(this.noteTimer);
        clearTimeout(this.drawerRestoreTimer);
        this.lineUpdateTimers.forEach(clearTimeout);
        this.lineUpdateTimers.clear();
        this.fitmentRetryTimers?.forEach(clearTimeout);
        document.documentElement.classList.remove('rimthin-mini-cart-open');
      }

      getEditorCopy(key, fallback = '') {
        if (!key) return fallback;
        for (const config of document.querySelectorAll('[data-rimthin-mini-cart-settings]')) {
          const value = config.getAttribute(`data-${key}`);
          if (value !== null) return value;
        }
        return fallback;
      }

      applyFitmentCopy(holder) {
        if (!holder) return;
        const parts = this.splitVehicle(holder.dataset.vehicleIndex);
        if (!parts.slice(0, 3).every(Boolean)) return;
        const fit = holder.dataset.vehicleFit;
        const title = holder.querySelector('.rimthin-mini-fitment__title');
        if (title) {
          if (fit === 'true') {
            title.textContent = `${this.getEditorCopy('fits-prefix', 'Fits Your')} ${parts.slice(0, 3).join(' ')}`;
          } else if (fit === 'false') {
            title.textContent = `${this.getEditorCopy('not-fit-prefix', "Doesn't fit")} ${parts.slice(0, 4).join(' ')}`;
          } else {
            title.textContent = `${this.getEditorCopy('checking-prefix', 'Checking fitment for')} ${parts.slice(0, 3).join(' ')}`;
          }
        }
        const location = holder.querySelector('.rimthin-mini-fitment__location');
        if (location) {
          location.textContent = `${this.getEditorCopy('location-label', 'Locations')}: ${parts[3] || ''}`;
        }
        const changeButton = holder.querySelector('[data-mini-cart-change-vehicle]');
        if (changeButton && fit === 'false') {
          changeButton.textContent = this.getEditorCopy('change-vehicle-label', 'Change Vehicle');
        }
        const partsLink = holder.querySelector('[data-mini-cart-parts-link]');
        if (partsLink) partsLink.textContent = this.getEditorCopy('parts-label', 'See parts that fit');
      }

      applyEditorSettings() {
        const configs = document.querySelectorAll('[data-rimthin-mini-cart-settings]');
        if (!configs.length) return;
        this.querySelectorAll('[data-mini-cart-copy]').forEach(element => {
          const key = element.dataset.miniCartCopy;
          let value = this.getEditorCopy(key, null);
          if (value === null) return;
          const amount = element.dataset.miniCartCopyAmount || '';
          if (amount) value = value.split('[amount]').join(amount);
          element.textContent = value;
          if (element.matches('[data-coupon-submit]')) element.dataset.label = value;
        });
        this.querySelectorAll('[data-mini-cart-copy-placeholder]').forEach(element => {
          const value = this.getEditorCopy(element.dataset.miniCartCopyPlaceholder, null);
          if (value !== null) element.setAttribute('placeholder', value);
        });
        this.querySelectorAll('[data-mini-cart-fitment]').forEach(holder => this.applyFitmentCopy(holder));
        const drawerTitle = this.getEditorCopy('drawer-title', '');
        if (drawerTitle) this.modal?.setAttribute('aria-label', drawerTitle);
      }

      syncOpenState() {
        const isOpen = this.modal?.getAttribute('open') === 'true';
        const wasOpen = this.drawerWasOpen === true;
        if (isOpen && !wasOpen) {
          this.pageScrollX = window.scrollX;
          this.pageScrollY = window.scrollY;
        }
        document.documentElement.classList.toggle('rimthin-mini-cart-open', isOpen);
        if (isOpen) {
          requestAnimationFrame(this.alignDrawerToViewport);
          if (!wasOpen) requestAnimationFrame(() => {
            this.hydrateFitmentResults();
            this.refreshFitment();
          });
        } else {
          this.modal?.querySelector(':scope > .mini-cart-wrap')?.style.removeProperty('right');
          if (wasOpen) this.restorePagePosition();
        }
        this.drawerWasOpen = isOpen;
      }

      restorePagePosition() {
        const left = Number.isFinite(this.pageScrollX) ? this.pageScrollX : 0;
        const top = Number.isFinite(this.pageScrollY) ? this.pageScrollY : window.scrollY;
        const opener = this.modal?.querySelector(':scope > .head-slot-cart-link');
        try { opener?.focus({ preventScroll: true }); } catch (error) { opener?.focus(); }
        const restore = () => window.scrollTo(left, top);
        restore();
        requestAnimationFrame(restore);
        clearTimeout(this.drawerRestoreTimer);
        this.drawerRestoreTimer = setTimeout(restore, 360);
      }

      alignDrawerToViewport() {
        if (this.modal?.getAttribute('open') !== 'true') return;
        const panel = this.modal.querySelector(':scope > .mini-cart-wrap');
        if (!panel) return;
        panel.style.setProperty('right', '0px', 'important');
        if (window.matchMedia('(max-width: 749px)').matches) return;
        const rect = panel.getBoundingClientRect();
        const transform = window.getComputedStyle(panel).transform;
        let translatedX = 0;
        if (transform && transform !== 'none' && window.DOMMatrixReadOnly) {
          try { translatedX = new DOMMatrixReadOnly(transform).m41; } catch (error) {}
        }
        const viewportOffset = Math.round(window.innerWidth - (rect.right - translatedX));
        if (Math.abs(viewportOffset) > 1) {
          panel.style.setProperty('right', `${-viewportOffset}px`, 'important');
        }
      }

      onClick(event) {
        const viewCart = event.target.closest('[data-mini-cart-view-cart]');
        if (viewCart) {
          event.preventDefault();
          event.stopPropagation();
          window.location.assign(viewCart.href);
          return;
        }

        const applyDiscount = event.target.closest('[data-mini-cart-coupon-apply]');
        if (applyDiscount) {
          event.preventDefault();
          const form = applyDiscount.closest('[data-mini-cart-coupon]');
          const code = form?.querySelector('input')?.value.trim();
          if (code) this.updateDiscount(code, false, form);
          else this.setFeedback(form?.querySelector('[data-coupon-status]'), 'Enter a discount code.', 'error');
          return;
        }

        const removeDiscount = event.target.closest('[data-mini-cart-discount-remove]');
        if (removeDiscount) {
          event.preventDefault();
          this.updateDiscount('', true);
          return;
        }

        const partsLink = event.target.closest('[data-mini-cart-parts-link]');
        if (partsLink) {
          const holder = partsLink.closest('[data-mini-cart-fitment]');
          if (
            !holder
            || partsLink.getAttribute('aria-disabled') === 'true'
            || !partsLink.href
          ) {
            event.preventDefault();
            return;
          }

          const vehicle = this.readHolderVehicle(holder);
          if (!vehicle?.index) return;

          this.syncVehicleBeforeNavigation(vehicle.index);
          if (
            event.button === 0
            && !event.metaKey
            && !event.ctrlKey
            && !event.shiftKey
            && !event.altKey
          ) {
            event.preventDefault();
            window.location.assign(partsLink.href);
          }
          return;
        }

        const changeVehicle = event.target.closest('[data-mini-cart-change-vehicle]');
        if (changeVehicle) {
          event.preventDefault();
          event.stopPropagation();
          const holder = changeVehicle.closest('[data-mini-cart-fitment]');
          if (holder) this.openVehicleEditor(event, holder);
          return;
        }
      }

      onQuantityClick(event) {
        const fitmentAction = event.target.closest('[data-mini-cart-change-vehicle]');
        if (fitmentAction) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const holder = fitmentAction.closest('[data-mini-cart-fitment]');
          if (holder) this.openVehicleEditor(event, holder);
          return;
        }

        const quantityButton = event.target.closest('.quantity-input-button');
        if (quantityButton) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const input = quantityButton.closest('.quantity-input')?.querySelector('.quantity-input-field');
          if (!input || input.disabled) return;
          const current = Math.max(1, Number.parseInt(input.value, 10) || 1);
          const quantity = quantityButton.name === 'plus' ? current + 1 : Math.max(1, current - 1);
          if (quantity === current) return;
          input.value = String(quantity);
          this.queueLineChange(input, quantity);
          return;
        }

        const removeButton = event.target.closest('[data-mini-cart-remove]');
        if (!removeButton) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const line = Number.parseInt(removeButton.dataset.index, 10);
        if (line > 0) {
          const input = removeButton.closest('.mini-cart-item')?.querySelector('.quantity-input-field');
          const timerKey = input?.dataset.itemKey || input;
          if (timerKey) {
            clearTimeout(this.lineUpdateTimers.get(timerKey));
            this.lineUpdateTimers.delete(timerKey);
          }
          this.changeLine(line, 0, removeButton);
        }
      }

      onChange(event) {
        if (event.target.matches('.quantity-input-field')) {
          event.preventDefault();
          event.stopPropagation();
          const quantity = Math.max(1, Number.parseInt(event.target.value, 10) || 1);
          event.target.value = String(quantity);
          this.queueLineChange(event.target, quantity, 0);
          return;
        }
        if (!event.target.matches('[data-mini-cart-note], [data-mini-cart-coupon] input')) return;
        event.stopPropagation();
        if (event.target.matches('[data-mini-cart-note]')) this.queueNoteUpdate(event.target);
      }

      onInput(event) {
        if (!event.target.matches('[data-mini-cart-note], [data-mini-cart-coupon] input')) return;
        event.stopPropagation();
        if (event.target.matches('[data-mini-cart-note]')) this.queueNoteUpdate(event.target);
      }

      onKeydown(event) {
        if (event.key === 'Enter' && event.target.matches('.quantity-input-field')) {
          event.preventDefault();
          event.stopPropagation();
          const quantity = Math.max(1, Number.parseInt(event.target.value, 10) || 1);
          event.target.value = String(quantity);
          this.queueLineChange(event.target, quantity, 0);
          return;
        }
        if (event.key !== 'Enter' || !event.target.matches('[data-mini-cart-coupon] input')) return;
        event.preventDefault();
        event.stopPropagation();
        const form = event.target.closest('[data-mini-cart-coupon]');
        const code = event.target.value.trim();
        if (code) this.updateDiscount(code, false, form);
        else this.setFeedback(form.querySelector('[data-coupon-status]'), 'Enter a discount code.', 'error');
      }

      setFeedback(element, message, state = '') {
        if (!element) return;
        element.textContent = message || '';
        if (state) element.dataset.state = state;
        else element.removeAttribute('data-state');
      }

      getMiniCart() {
        return this.closest('mini-cart');
      }

      scheduleFitmentRefresh(delays = [120, 500, 1400, 2600]) {
        this.fitmentRetryTimers?.forEach(clearTimeout);
        this.fitmentRetryTimers = delays.map(delay => setTimeout(() => {
          if (this.isConnected) this.refreshFitment();
        }, delay));
      }

      getFitmentResultCacheKey(holder) {
        const identity = holder?.dataset.fitmentIdentity || holder?.dataset.fitmentKey || '';
        return `rimthin-cart-fitment-result-${this.hashFitmentIdentity(identity)}`;
      }

      getVehicleFingerprint(index) {
        return this.splitVehicle(index).slice(0, 4).join('\u001f');
      }

      readFitmentResult(holder) {
        try {
          const raw = sessionStorage.getItem(this.getFitmentResultCacheKey(holder));
          if (!raw) return null;
          const result = JSON.parse(raw);
          const isFresh = Number.isFinite(result?.savedAt) && Date.now() - result.savedAt < 12 * 60 * 60 * 1000;
          if (!isFresh || typeof result?.fits !== 'boolean' || !Array.isArray(result?.parts)) return null;
          return result;
        } catch (error) {
          return null;
        }
      }

      writeFitmentResult(holder, result) {
        try {
          sessionStorage.setItem(this.getFitmentResultCacheKey(holder), JSON.stringify({
            ...result,
            savedAt: Date.now()
          }));
        } catch (error) {}
      }

      clearFitmentResult(holder) {
        try { sessionStorage.removeItem(this.getFitmentResultCacheKey(holder)); }
        catch (error) {}
      }

      hydrateFitmentResults() {
        for (const holder of this.querySelectorAll('[data-mini-cart-fitment]')) {
          const active = this.readHolderVehicle(holder);
          if (!active?.index) continue;
          const fingerprint = this.getVehicleFingerprint(active.index);
          const cached = this.readFitmentResult(holder);
          if (cached?.vehicleFingerprint === fingerprint) {
            this.renderFitment(holder, cached.fits, cached.parts, cached.partsUrl || '', cached.signature || '', false);
            continue;
          }

          const initialIndex = holder.dataset.vehicleIndex || '';
          const initialFit = holder.dataset.vehicleFit;
          if (
            this.getVehicleFingerprint(initialIndex) === fingerprint &&
            (initialFit === 'true' || initialFit === 'false')
          ) {
            const parts = this.splitVehicle(initialIndex);
            this.renderFitment(
              holder,
              initialFit === 'true',
              parts,
              '',
              this.getFitmentSignature(holder, { index: initialIndex }),
              false
            );
          } else {
            holder.hidden = true;
          }
        }
      }

      captureFitmentSnapshot() {
        const snapshot = new Map();
        for (const holder of this.querySelectorAll('[data-mini-cart-fitment]')) {
          const signature = holder.dataset.rimthinFitmentSignature || '';
          const fit = holder.dataset.vehicleFit;
          const vehicle = this.readHolderVehicle(holder);
          if (!signature || !vehicle?.index || (fit !== 'true' && fit !== 'false')) continue;
          const identity = this.hashFitmentIdentity(holder.dataset.fitmentIdentity || holder.dataset.fitmentKey || '');
          snapshot.set(identity, {
            index: vehicle.index,
            fits: fit === 'true',
            partsUrl: holder.querySelector('[data-mini-cart-parts-link]')?.getAttribute('href') || '',
            signature
          });
        }
        return snapshot;
      }

      restoreFitmentSnapshot(snapshot) {
        if (!(snapshot instanceof Map) || !snapshot.size) return;
        const app = window.easysearch;
        for (const holder of this.querySelectorAll('[data-mini-cart-fitment]')) {
          const identity = this.hashFitmentIdentity(holder.dataset.fitmentIdentity || holder.dataset.fitmentKey || '');
          const state = snapshot.get(identity);
          const vehicle = this.readHolderVehicle(holder);
          if (!state || vehicle?.index !== state.index) continue;
          const parts = this.splitVehicle(state.index);
          const row = this.getVehicleRow(app, parts);
          const expectedSignature = row ? this.getFitmentSignature(holder, row) : '';
          if (expectedSignature && expectedSignature !== state.signature) continue;
          this.renderFitment(
            holder,
            state.fits,
            row?.parts || parts,
            state.partsUrl,
            expectedSignature || state.signature
          );
        }
      }

      getSections() {
        const miniCart = this.getMiniCart();
        if (typeof miniCart?.getSectionsToRender === 'function') {
          return miniCart.getSectionsToRender().map(section => section.section);
        }
        return ['header', this.dataset.sectionContent, this.dataset.sectionFooter];
      }

      async postCart(payload, includeSections = true, endpointUrl = this.dataset.updateUrl, sectionIds = null) {
        const baseUrl = endpointUrl || this.dataset.updateUrl;
        const endpoint = baseUrl.endsWith('.js') ? baseUrl : `${baseUrl}.js`;
        const requestBody = includeSections
          ? {
              ...payload,
              sections: sectionIds || this.getSections(),
              sections_url: `${window.location.pathname}${window.location.search}`
            }
          : payload;
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(requestBody)
        });
        const cart = await response.json();
        if (!response.ok || cart.errors) throw new Error(cart.description || cart.message || 'Unable to update your cart.');
        return cart;
      }

      renderCart(cart, feedback = {}) {
        const miniCart = this.getMiniCart();
        if (typeof miniCart?.renderContents !== 'function') throw new Error('Unable to refresh your cart.');
        const fitmentSnapshot = this.captureFitmentSnapshot();
        const drawerWasOpen = this.modal?.getAttribute('open') === 'true';
        const scrollTop = feedback.scrollTop ?? this.querySelector('.rimthin-mini-cart-scroll')?.scrollTop ?? 0;
        miniCart.renderContents(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        const nextController = miniCart.querySelector('rimthin-mini-cart-controller') || this;
        const nextModal = nextController.closest('header-mini-cart-dropdown-modal');
        nextController.applyEditorSettings?.();
        if (typeof nextController.restoreFitmentSnapshot === 'function') {
          nextController.restoreFitmentSnapshot(fitmentSnapshot);
        }
        if (drawerWasOpen && nextModal) {
          nextModal.setAttribute('open', 'true');
          document.documentElement.classList.add('rimthin-mini-cart-open');
          nextController.drawerWasOpen = true;
        }
        if (feedback.type === 'coupon') {
          nextController.setFeedback(nextController.querySelector('[data-coupon-status]'), feedback.message, feedback.state);
        }
        if (feedback.type === 'note') {
          nextController.setFeedback(nextController.querySelector('[data-note-status]'), feedback.message, feedback.state);
        }
        requestAnimationFrame(() => {
          const nextScroll = nextController.querySelector('.rimthin-mini-cart-scroll');
          if (nextScroll) nextScroll.scrollTop = scrollTop;
          nextController.alignDrawerToViewport();
        });
        nextController.refreshFitment?.();
        nextController.scheduleFitmentRefresh?.();
      }

      getRenderedSection(cart, sectionId) {
        const html = cart.sections?.[sectionId];
        if (typeof html !== 'string') return null;
        const template = document.createElement('template');
        template.innerHTML = html;
        return template.content;
      }

      findItemByIdentity(root, item) {
        if (!root || !item) return null;
        const identity = item.dataset.itemIdentity || '';
        const key = item.dataset.itemKey || '';
        return [...root.querySelectorAll('.mini-cart-item')].find(candidate => (
          (identity && candidate.dataset.itemIdentity === identity)
          || (key && candidate.dataset.itemKey === key)
        )) || null;
      }

      updateHeaderCartCount(cart) {
        document.querySelectorAll('.head-slot-cart-link-quantity').forEach(element => {
          element.textContent = String(cart.item_count || 0);
          element.hidden = !cart.item_count;
        });
      }

      patchDrawerSummary(cart, footerFragment) {
        const footer = this.querySelector('#header-mini-cart-footer');
        if (!footer || !footerFragment) return;
        if (!cart.item_count) {
          footer.replaceChildren(...footerFragment.cloneNode(true).childNodes);
          return;
        }
        for (const selector of ['.rimthin-mini-shipping', '.rimthin-mini-summary__rows']) {
          const current = footer.querySelector(selector);
          const next = footerFragment.querySelector(selector);
          if (current && next) current.replaceWith(next.cloneNode(true));
          else if (!current && next) footer.querySelector('.rimthin-mini-summary')?.prepend(next.cloneNode(true));
          else current?.remove();
        }
      }

      patchDrawerItems(contentFragment) {
        if (!contentFragment) return;
        for (const item of [...this.querySelectorAll('.mini-cart-item')]) {
          const next = this.findItemByIdentity(contentFragment, item);
          if (!next) {
            item.remove();
            continue;
          }

          const preserveQuantity = item.dataset.pendingQuantity !== undefined;
          const currentInput = item.querySelector('.quantity-input-field');
          const nextInput = next.querySelector('.quantity-input-field');
          item.id = next.id;
          item.dataset.itemKey = next.dataset.itemKey || '';

          if (currentInput && nextInput) {
            if (!preserveQuantity) currentInput.value = nextInput.value;
            currentInput.dataset.previous = nextInput.value;
            currentInput.dataset.index = nextInput.dataset.index;
            currentInput.dataset.itemKey = nextInput.dataset.itemKey;
            currentInput.id = nextInput.id;
            const currentLabel = currentInput.closest('.quantity-input')?.querySelector('label');
            const nextLabel = nextInput.closest('.quantity-input')?.querySelector('label');
            if (currentLabel && nextLabel) currentLabel.htmlFor = nextLabel.htmlFor;
          }

          const currentPrices = item.querySelectorAll('.mini-cart-item-price');
          const nextPrices = next.querySelectorAll('.mini-cart-item-price');
          currentPrices.forEach((price, index) => {
            if (nextPrices[index]) price.replaceWith(nextPrices[index].cloneNode(true));
          });

          const currentRemove = item.querySelector('[data-mini-cart-remove]');
          const nextRemove = next.querySelector('[data-mini-cart-remove]');
          if (currentRemove && nextRemove) {
            currentRemove.href = nextRemove.href;
            currentRemove.dataset.index = nextRemove.dataset.index;
            const currentRemoveWrapper = currentRemove.closest('cart-remove-button');
            const nextRemoveWrapper = nextRemove.closest('cart-remove-button');
            currentRemoveWrapper?.setAttribute('data-index', nextRemove.dataset.index);
            if (currentRemoveWrapper && nextRemoveWrapper) currentRemoveWrapper.id = nextRemoveWrapper.id;
          }

          const currentError = item.querySelector('.cart-item-error');
          const nextError = next.querySelector('.cart-item-error');
          if (currentError && nextError) currentError.id = nextError.id;
        }
      }

      reconcileLineCart(cart) {
        const contentFragment = this.getRenderedSection(cart, this.dataset.sectionContent);
        const footerFragment = this.getRenderedSection(cart, this.dataset.sectionFooter);
        const content = this.querySelector('#header-mini-cart-content');

        if (!cart.item_count && content && contentFragment) {
          content.replaceChildren(...contentFragment.cloneNode(true).childNodes);
        } else {
          this.patchDrawerItems(contentFragment);
        }
        this.patchDrawerSummary(cart, footerFragment);
        this.updateHeaderCartCount(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        this.applyEditorSettings();
        this.hydrateFitmentResults();
        this.refreshFitment();
      }

      queueLineChange(input, quantity, delay = 80) {
        const item = input.closest('.mini-cart-item');
        if (item?.dataset.updatePending === 'true') {
          item.dataset.pendingQuantity = String(quantity);
          return;
        }
        const timerKey = input.dataset.itemKey || input;
        clearTimeout(this.lineUpdateTimers.get(timerKey));
        const timer = setTimeout(() => {
          this.lineUpdateTimers.delete(timerKey);
          this.changeLine(Number.parseInt(input.dataset.index, 10), quantity, input);
        }, delay);
        this.lineUpdateTimers.set(timerKey, timer);
      }

      setLineBusy(line, busy) {
        const item = this.querySelector(`#MiniCartItem-${line}`);
        if (!item) return;
        if (busy) item.setAttribute('aria-busy', 'true');
        else item.removeAttribute('aria-busy');
        item.querySelectorAll('.quantity-input-button, .quantity-input-field, [data-mini-cart-remove]').forEach(control => {
          if ('disabled' in control) control.disabled = busy;
          if (busy) control.setAttribute('aria-disabled', 'true');
          else control.removeAttribute('aria-disabled');
        });
      }

      async changeLine(line, quantity, source) {
        const item = source?.closest('.mini-cart-item') || this.querySelector(`#MiniCartItem-${line}`);
        if (!item) return;
        const input = item.querySelector('.quantity-input-field');
        const itemKey = input?.dataset.itemKey || item.dataset.itemKey;
        if (!itemKey) return;
        if (item.dataset.updatePending === 'true') {
          item.dataset.pendingQuantity = String(quantity);
          if (quantity === 0) item.hidden = true;
          return;
        }

        const previous = Number.parseInt(input?.dataset.previous, 10) || Number.parseInt(input?.value, 10) || 1;
        item.dataset.updatePending = 'true';
        if (quantity === 0) item.hidden = true;
        try {
          const cart = await this.postCart(
            { id: itemKey, quantity },
            true,
            this.dataset.changeUrl,
            [this.dataset.sectionContent, this.dataset.sectionFooter]
          );
          this.reconcileLineCart(cart);
          if (!item.isConnected) return;
          const pending = item.dataset.pendingQuantity;
          delete item.dataset.pendingQuantity;
          delete item.dataset.updatePending;
          item.hidden = false;
          if (pending !== undefined && Number(pending) !== quantity) {
            this.changeLine(Number.parseInt(input?.dataset.index, 10), Number(pending), input || item);
          }
        } catch (error) {
          delete item.dataset.updatePending;
          const pending = item.dataset.pendingQuantity;
          delete item.dataset.pendingQuantity;
          item.hidden = false;
          if (input && pending === undefined) input.value = String(previous);
          const message = item.querySelector('.cart-item-error-text');
          if (message) message.textContent = error.message || 'Unable to update this item.';
          if (pending !== undefined) {
            this.changeLine(Number.parseInt(input?.dataset.index, 10), Number(pending), input || item);
          }
        }
      }

      cartHasDiscount(cart, code) {
        const expected = String(code || '').trim().toLowerCase();
        const titles = [
          ...(cart.cart_level_discount_applications || []).map(discount => discount.title),
          ...(cart.items || []).flatMap(item => [
            ...(item.discounts || []).map(discount => discount.title),
            ...(item.discount_allocations || []).map(allocation => allocation.discount_application?.title)
          ])
        ];
        return titles.some(title => String(title || '').trim().toLowerCase() === expected);
      }

      async updateDiscount(code, removed = false, suppliedForm = null) {
        const form = suppliedForm || this.querySelector('[data-mini-cart-coupon]');
        if (!form || form.hasAttribute('aria-busy')) return;
        const button = form.querySelector('[data-coupon-submit]');
        let previousCodes = [];
        try { previousCodes = JSON.parse(form.dataset.appliedDiscounts || '[]'); } catch (error) {}
        form.setAttribute('aria-busy', 'true');
        if (button) {
          button.disabled = true;
          button.textContent = 'Applying...';
        }
        this.setFeedback(form.querySelector('[data-coupon-status]'), '');

        try {
          let cart = await this.postCart({ discount: code });
          if (code && !this.cartHasDiscount(cart, code)) {
            if (previousCodes.length) cart = await this.postCart({ discount: previousCodes.join(',') });
            this.renderCart(cart, { type: 'coupon', message: 'This discount code could not be applied.', state: 'error' });
            return;
          }
          this.renderCart(cart, {
            type: 'coupon',
            message: removed ? 'Discount code removed.' : 'Discount code applied.',
            state: 'success'
          });
        } catch (error) {
          form.removeAttribute('aria-busy');
          if (button) {
            button.disabled = false;
            button.textContent = button.dataset.label || 'Apply';
          }
          this.setFeedback(form.querySelector('[data-coupon-status]'), error.message, 'error');
        }
      }

      queueNoteUpdate(textarea) {
        clearTimeout(this.noteTimer);
        this.setFeedback(this.querySelector('[data-note-status]'), 'Saving...');
        this.noteTimer = setTimeout(() => this.saveNote(textarea.value), 500);
      }

      async saveNote(note) {
        try {
          await this.postCart({ note }, false);
          this.setFeedback(this.querySelector('[data-note-status]'), 'Order note saved.', 'success');
        } catch (error) {
          this.setFeedback(this.querySelector('[data-note-status]'), error.message, 'error');
        }
      }

      readStoredValue(key) {
        try {
          const value = localStorage.getItem(key);
          if (value) return JSON.parse(value);
        } catch (error) {}
        const match = document.cookie.match(new RegExp(`(?:^|; )${key}=([^;]*)`));
        if (!match) return null;
        try { return JSON.parse(decodeURIComponent(match[1])); }
        catch (error) { return decodeURIComponent(match[1]); }
      }

      writeStoredValue(key, value) {
        const serialized = JSON.stringify(value);
        try { localStorage.setItem(key, serialized); }
        catch (error) {
          document.cookie = `${key}=${encodeURIComponent(serialized)};max-age=31536000;path=/;SameSite=Lax`;
        }
        return serialized;
      }

      getFitmentStorageKey(holder) {
        const identity = holder.dataset.fitmentIdentity || holder.dataset.fitmentKey || '';
        return `rimthin-cart-fitment-vehicle-${this.hashFitmentIdentity(identity)}`;
      }

      getLegacyFitmentStorageKey(holder) {
        return `rimthin-cart-fitment-vehicle-${holder.dataset.fitmentKey || ''}`;
      }

      hashFitmentIdentity(identity) {
        let first = 2166136261;
        let second = 2246822519;
        for (const character of String(identity || '')) {
          const code = character.codePointAt(0);
          first = Math.imul(first ^ code, 16777619);
          second = Math.imul(second ^ code, 3266489917);
        }
        return `${(first >>> 0).toString(36)}-${(second >>> 0).toString(36)}`;
      }

      splitVehicle(index) {
        return String(index || '').replace(/,+$/, '').split(',').map(value => value.trim());
      }

      hasCompleteVehicle(parts) {
        return parts.length >= 4 && parts.slice(0, 4).every(Boolean);
      }

      readHolderVehicle(holder) {
        const initialIndex = holder.dataset.vehicleIndex || '';
        if (!initialIndex) return null;
        const key = this.getFitmentStorageKey(holder);
        let saved = this.readStoredValue(key);
        if (typeof saved?.index !== 'string' || !saved.index) {
          saved = this.readStoredValue(this.getLegacyFitmentStorageKey(holder));
          if (typeof saved?.index === 'string' && saved.index) this.writeStoredValue(key, saved);
        }
        if (typeof saved?.index === 'string' && saved.index) return saved;
        const initial = {
          index: initialIndex,
          label: this.splitVehicle(initialIndex).slice(0, 4).join(' ')
        };
        this.writeStoredValue(key, initial);
        return initial;
      }

      persistHolderVehicle(holder, index) {
        if (!holder || !index) return;
        holder.dataset.vehicleIndex = index;
        holder.hidden = true;
        delete holder.dataset.rimthinFitmentSignature;
        delete holder.dataset.rimthinFitmentHydrated;
        this.clearFitmentResult(holder);
        const key = this.getFitmentStorageKey(holder);
        const serialized = this.writeStoredValue(key, {
          index,
          label: this.splitVehicle(index).slice(0, 4).join(' ')
        });
        this.notifyStorageChanged(key, serialized);
      }

      getVehicleRow(app, parts) {
        if (!app?.tree || !this.hasCompleteVehicle(parts)) return null;
        for (const [index, urls] of Object.entries(app.tree)) {
          const rowParts = this.splitVehicle(index);
          if (!parts.slice(0, 4).every((part, position) => rowParts[position] === part)) continue;
          return {
            index,
            parts: rowParts,
            url: Array.isArray(urls) ? urls.find(value => typeof value === 'string' && value) || '' : ''
          };
        }
        return null;
      }

      getIndexUrl(app, index, fallback = '') {
        if (!index) return '';
        if (typeof app.getUrlByIndex === 'function') {
          const exact = app.getUrlByIndex(index);
          if (exact) return exact;
          const normalized = index.endsWith(',') ? index : `${index},`;
          const normalizedUrl = app.getUrlByIndex(normalized);
          if (normalizedUrl) return normalizedUrl;
        }
        const urls = app.tree?.[index];
        return Array.isArray(urls)
          ? urls.find(value => typeof value === 'string' && value) || fallback
          : fallback;
      }

      getPartsUrl(app, row) {
        if (!row) return '';
        const raw = this.getIndexUrl(app, row.index, row.url);
        return typeof app.getPreparedUrl === 'function' ? app.getPreparedUrl(raw) : raw;
      }

      getFitmentSignature(holder, row) {
        if (!holder || !row?.index) return '';
        const identity = this.hashFitmentIdentity(holder.dataset.fitmentIdentity || holder.dataset.fitmentKey || '');
        return [
          identity,
          row.index,
          holder.dataset.productUrl || '',
          holder.dataset.productVariant || ''
        ].join('|');
      }

      notifyStorageChanged(key, newValue) {
        try {
          window.dispatchEvent(new StorageEvent('storage', {
            key,
            newValue,
            storageArea: localStorage
          }));
        } catch (error) {
          const storageEvent = new Event('storage');
          Object.defineProperties(storageEvent, {
            key: { value: key },
            newValue: { value: newValue }
          });
          window.dispatchEvent(storageEvent);
        }
      }

      persistEasySearchIndex(app, index) {
        if (!index) return;
        const delimiter = 'easysearch-preselect-delimiter';
        const value = index.replaceAll(',', delimiter);
        const keys = ['easysearch-preselect', 'easysearch-preselect-fitment'];

        if (typeof app?.setCookie === 'function') {
          keys.forEach(key => app.setCookie(key, value));
          return;
        }

        const payload = {
          value,
          expires: String(Date.now() + 60 * 60 * 1000)
        };
        keys.forEach(key => this.writeStoredValue(key, payload));
      }

      getGarageItemIndex(item) {
        return typeof item?.esGarageIndex === 'string'
          ? item.esGarageIndex
          : item?.dataset?.easysearchIndex || item?.dataset?.index || '';
      }

      selectGarageVehicle(app, garage, index) {
        const items = [...garage.querySelectorAll('.easysearch-garage-item')];
        const selectedItem = items.find(item => this.getGarageItemIndex(item) === index);
        if (!selectedItem) return;

        const selectedItemText = typeof app.getPhrase === 'function'
          ? app.getPhrase(app.settings?.form, 'garage_selected_item')
          : '';
        items.forEach(item => {
          const selected = item === selectedItem;
          item.dataset.selected = selected ? '1' : '0';
          item.dataset.selectedItemText = selected ? selectedItemText : '';
        });
      }

      activateGarageVehicle(app, garage, index, notify = true) {
        if (!app || !index) return;
        app.curIndex = index;
        app.preSelect = index.split(',');
        app.preSelectFitment = index.split(',');
        this.persistEasySearchIndex(app, index);
        if (garage) this.selectGarageVehicle(app, garage, index);

        const label = this.splitVehicle(index).slice(0, 3).join(' ');
        const serialized = this.writeStoredValue(
          'rimthin-easysearch-active-vehicle',
          { index, label }
        );
        if (notify) this.notifyStorageChanged('rimthin-easysearch-active-vehicle', serialized);
      }

      syncVehicleBeforeNavigation(index) {
        const app = window.easysearch;
        if (!app || !index) return;

        const garage = document.querySelector('.easysearch-garage-widget');
        const { holder } = garage ? this.getGarageForm(garage) : {};
        const url = this.getIndexUrl(app, index);
        if (holder) {
          holder.esparams = {
            ...(holder.esparams || {}),
            index,
            url
          };
        }

        this.activateGarageVehicle(app, garage, index, false);

        const vehicleExists = [...(garage?.querySelectorAll('.easysearch-garage-item') || [])]
          .some(item => this.getGarageItemIndex(item) === index);
        if (
          garage
          && holder
          && !vehicleExists
          && typeof app._garageActionAddItem === 'function'
        ) {
          app._garageActionAddItem(garage);
          if (typeof app.setCookie === 'function') {
            app.setCookie('easysearch-garage-item-just-added', '');
          }
        }

        if (holder && typeof app.saveSearchParams === 'function') {
          app.saveSearchParams(holder);
        }
        this.activateGarageVehicle(app, garage, index);
      }

      setGarageExpanded(garage, expanded) {
        garage.classList.toggle('easysearch-garage-opened', expanded);
        document.documentElement.classList.toggle('rimthin-garage-modal-open', expanded);
        document.querySelectorAll('[data-header-garage] button').forEach(button => {
          button.setAttribute('aria-expanded', String(expanded));
        });
      }

      restoreActiveRuntime(app) {
        const active = this.readStoredValue('rimthin-easysearch-active-vehicle');
        const index = typeof active?.index === 'string' ? active.index : '';
        if (!app || !index) return;
        app.curIndex = index;
        app.preSelect = index.split(',');
        app.preSelectFitment = index.split(',');
      }

      getGarageForm(garage) {
        const wrapper = garage.querySelector('.easysearch-garage-select-wrapper');
        return {
          wrapper,
          holder: wrapper?.querySelector('.easysearch-holder'),
          confirmButton: wrapper?.querySelector('[data-easysearch-action="garage-add-item"]')
        };
      }

      resolveGarageVehicleIndex(app, holder) {
        const index = typeof app.getCurrentIndex === 'function'
          ? app.getCurrentIndex(holder)
          : holder.esparams?.index || '';
        return this.getVehicleRow(app, this.splitVehicle(index))?.index || '';
      }

      updateGarageConfirmButton(app, garage) {
        if (!garage.classList.contains('rimthin-fitment-editing')) return;
        const { holder, confirmButton } = this.getGarageForm(garage);
        if (!holder || !confirmButton) return;
        const index = this.resolveGarageVehicleIndex(app, holder);
        const fallback = holder.esparams?.index === index ? holder.esparams?.url || '' : '';
        const disabled = !index || !this.getIndexUrl(app, index, fallback);
        confirmButton.classList.add('rimthin-fitment-confirm');
        confirmButton.toggleAttribute('disabled', disabled);
        confirmButton.setAttribute('aria-disabled', String(disabled));
        confirmButton.removeAttribute('onclick');
        confirmButton.dataset.rimthinVehicleIndex = index;
        const title = confirmButton.querySelector('.easysearch-btn-title');
        if (title) title.textContent = this.dataset.fitmentConfirmLabel;
        else confirmButton.textContent = this.dataset.fitmentConfirmLabel;
      }

      reopenDrawerAfterVehicleEditor() {
        this.reopenAfterVehicleEditor = false;
        if (!this.modal) return;
        this.modal.setAttribute('open', 'true');
        document.documentElement.classList.add('rimthin-mini-cart-open');
        this.drawerWasOpen = true;
        requestAnimationFrame(this.alignDrawerToViewport);
      }

      closeVehicleEditor(garage) {
        const app = window.easysearch;
        if (typeof app?._garageActionCancel === 'function') app._garageActionCancel(garage);
        else {
          garage.querySelector('.easysearch-garage-list-wrapper')?.classList.remove('easysearch-hidden');
          garage.querySelector('.easysearch-garage-select-wrapper')?.classList.add('easysearch-hidden');
        }
        this.restoreActiveRuntime(app);
        this.activeFitmentHolder = null;
        garage.classList.remove('rimthin-fitment-editing');
        this.setGarageExpanded(garage, false);
        this.reopenDrawerAfterVehicleEditor();
      }

      bindGarageEditor(app, garage) {
        garage.rimthinMiniCartFitmentOwner = this;
        if (garage.dataset.rimthinMiniCartFitmentReady === 'true') return;
        garage.dataset.rimthinMiniCartFitmentReady = 'true';
        garage.addEventListener('change', event => {
          if (!event.target.closest('.easysearch-garage-select-wrapper')) return;
          setTimeout(() => {
            const owner = garage.rimthinMiniCartFitmentOwner;
            if (owner?.isConnected) owner.updateGarageConfirmButton(window.easysearch || app, garage);
          });
        });
        garage.addEventListener('click', event => {
          const owner = garage.rimthinMiniCartFitmentOwner;
          const runtimeApp = window.easysearch || app;
          if (!owner?.isConnected) return;
          const action = event.target.closest('[data-easysearch-action]');
          if (!action || !garage.classList.contains('rimthin-fitment-editing')) return;
          const type = action.dataset.easysearchAction;
          if (type === 'garage-cancel') {
            event.preventDefault();
            event.stopImmediatePropagation();
            owner.closeVehicleEditor(garage);
            return;
          }
          if (type === 'garage-toggle') {
            setTimeout(() => {
              if (!garage.classList.contains('easysearch-garage-opened')) {
                garage.classList.remove('rimthin-fitment-editing');
                owner.reopenDrawerAfterVehicleEditor();
              }
            });
            return;
          }
          if (type !== 'garage-add-item' || !action.classList.contains('rimthin-fitment-confirm')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (action.hasAttribute('disabled')) return;
          const { holder } = owner.getGarageForm(garage);
          if (!holder) return;
          const index = owner.resolveGarageVehicleIndex(runtimeApp, holder);
          const fallback = holder.esparams?.index === index ? holder.esparams?.url || '' : '';
          const url = owner.getIndexUrl(runtimeApp, index, fallback);
          if (!index || !url) return;
          const targetHolder = owner.activeFitmentHolder;
          if (!targetHolder?.isConnected) return;
          holder.esparams = { ...(holder.esparams || {}), index, url };
          owner.persistHolderVehicle(targetHolder, index);
          owner.closeVehicleEditor(garage);
          owner.refreshFitment(targetHolder);
        }, true);
      }

      openVehicleEditor(event, fitmentHolder) {
        event?.preventDefault();
        event?.stopPropagation();
        this.activeFitmentHolder = fitmentHolder;
        this.reopenAfterVehicleEditor = true;
        this.reopenDrawerAfterVehicleEditor();
        let opened = false;
        const open = () => {
          if (opened) return true;
          const app = window.easysearch;
          const garage = document.querySelector('.easysearch-garage-widget');
          const list = garage?.querySelector('.easysearch-garage-list-wrapper');
          const { wrapper, holder } = garage ? this.getGarageForm(garage) : {};
          if (!app || !garage || !list || !wrapper || !holder || typeof app.searchFormFillAllSelects !== 'function') {
            return false;
          }
          this.bindGarageEditor(app, garage);
          list.classList.add('easysearch-hidden');
          wrapper.classList.remove('easysearch-hidden');
          garage.classList.add('rimthin-fitment-editing');
          this.setGarageExpanded(garage, true);
          this.reopenDrawerAfterVehicleEditor();
          const active = this.readHolderVehicle(fitmentHolder);
          const index = active?.index || app.curIndex || '';
          if (index) app.searchFormFillAllSelects(holder, this.splitVehicle(index));
          this.updateGarageConfirmButton(app, garage);
          requestAnimationFrame(() => holder.querySelector('select')?.focus({ preventScroll: true }));
          opened = true;
          return true;
        };
        if (open()) return;
        document.addEventListener('easysearch_garage_rendered', open, { once: true });
        const toggles = [...document.querySelectorAll('[data-header-garage] button, .easysearch-garage-custom-toggler')];
        (toggles.find(button => button.getClientRects().length) || toggles[0])?.click();
        setTimeout(() => {
          if (!open()) this.reopenDrawerAfterVehicleEditor();
        }, 250);
      }

      async withProductContext(app, context, callback) {
        const pageInfo = app.pageInfo || (app.pageInfo = {});
        const keys = ['productTags', 'productTagsSet', 'productTagsLegacySet', 'productTagsHasUniversalTag', 'productCollections', 'productVariant'];
        const snapshot = new Map(keys.map(key => [key, {
          exists: Object.prototype.hasOwnProperty.call(pageInfo, key),
          value: pageInfo[key]
        }]));
        const runtime = { curIndex: app.curIndex, preSelect: app.preSelect, preSelectFitment: app.preSelectFitment };
        pageInfo.productTags = context.tags;
        pageInfo.productCollections = context.collections;
        pageInfo.productVariant = context.variant;
        app.curIndex = context.index;
        app.preSelect = context.index.split(',');
        app.preSelectFitment = context.index.split(',');
        if (typeof app._prepareProductTagsData === 'function') app._prepareProductTagsData();
        else {
          pageInfo.productTagsSet = new Set(context.tags);
          pageInfo.productTagsLegacySet = new Set(context.tags);
        }
        try {
          return await callback();
        } finally {
          for (const [key, state] of snapshot) {
            if (state.exists) pageInfo[key] = state.value;
            else delete pageInfo[key];
          }
          app.curIndex = runtime.curIndex;
          app.preSelect = runtime.preSelect;
          app.preSelectFitment = runtime.preSelectFitment;
        }
      }

      renderFitment(holder, fits, parts, partsUrl, signature, persistResult = true) {
        holder.classList.remove('is-pending');
        holder.classList.toggle('is-fit', fits);
        holder.classList.toggle('is-not-fit', !fits);
        holder.hidden = false;
        holder.dataset.vehicleFit = fits ? 'true' : 'false';
        holder.dataset.rimthinFitmentSignature = signature;
        holder.dataset.rimthinFitmentHydrated = 'true';
        const title = document.createElement(fits ? 'button' : 'p');
        title.className = 'rimthin-mini-fitment__title';
        if (fits) {
          title.type = 'button';
          title.dataset.miniCartChangeVehicle = '';
        }
        title.textContent = fits
          ? `${this.getEditorCopy('fits-prefix', 'Fits Your')} ${parts.slice(0, 3).join(' ')}`
          : `${this.getEditorCopy('not-fit-prefix', "Doesn't fit")} ${parts.slice(0, 4).join(' ')}`;
        holder.querySelector('.rimthin-mini-fitment__title')?.replaceWith(title);
        const location = holder.querySelector('.rimthin-mini-fitment__location');
        const actions = holder.querySelector('.rimthin-mini-fitment__actions');
        const link = holder.querySelector('[data-mini-cart-parts-link]');
        location.textContent = `${this.getEditorCopy('location-label', 'Locations')}: ${parts[3] || ''}`;
        location.hidden = !fits;
        actions.hidden = fits;
        const changeButton = actions.querySelector('[data-mini-cart-change-vehicle]');
        if (changeButton) changeButton.textContent = this.getEditorCopy('change-vehicle-label', 'Change Vehicle');
        if (link) link.textContent = this.getEditorCopy('parts-label', 'See parts that fit');
        if (partsUrl) {
          link.href = partsUrl;
          link.removeAttribute('aria-disabled');
        } else {
          link.removeAttribute('href');
          link.setAttribute('aria-disabled', 'true');
        }
        if (persistResult) {
          this.writeFitmentResult(holder, {
            vehicleFingerprint: this.getVehicleFingerprint(parts.join(',')),
            fits: Boolean(fits),
            parts,
            partsUrl: partsUrl || '',
            signature: signature || ''
          });
        }
      }

      refreshFitment(targetHolder = null) {
        const holders = targetHolder ? [targetHolder] : [...this.querySelectorAll('[data-mini-cart-fitment]')];
        const app = window.easysearch;
        if (!app || typeof app.fitmentCheck !== 'function' || typeof app.getUrlDetails !== 'function') return;

        for (const holder of holders) {
          const active = this.readHolderVehicle(holder);
          const parts = this.splitVehicle(active?.index);
          const row = this.getVehicleRow(app, parts);
          if (!row?.url) {
            if (holder.dataset.rimthinFitmentHydrated !== 'true') holder.hidden = true;
            continue;
          }
          const productUrl = new URL(holder.dataset.productUrl, window.location.origin).href;
          const productDetails = app.getUrlDetails(productUrl);
          if (!productDetails) continue;
          const signature = this.getFitmentSignature(holder, row);
          if (
            holder.dataset.rimthinFitmentSignature !== signature
            && holder.dataset.rimthinFitmentHydrated !== 'true'
          ) holder.hidden = true;
          if (holder.dataset.rimthinFitmentPendingSignature === signature) continue;
          holder.dataset.rimthinFitmentPendingSignature = signature;
          const run = (this.fitmentRuns.get(holder) || 0) + 1;
          this.fitmentRuns.set(holder, run);
          let tags = [];
          let collections = [];
          try {
            tags = JSON.parse(holder.dataset.productTags || '[]');
            collections = JSON.parse(holder.dataset.productCollections || '[]');
          } catch (error) {}
          const context = {
            tags: Array.isArray(tags) ? tags : [],
            collections: Array.isArray(collections) ? collections : [],
            variant: holder.dataset.productVariant || '',
            index: row.index
          };
          const task = this.fitmentQueue.then(() => this.withProductContext(
            app,
            context,
            () => app.fitmentCheck(row.url, productDetails)
          ));
          this.fitmentQueue = task.catch(() => {});
          task.then(fits => {
            if (run !== this.fitmentRuns.get(holder) || !holder.isConnected || !this.isConnected) return;
            const currentVehicle = this.readHolderVehicle(holder);
            const currentRow = this.getVehicleRow(app, this.splitVehicle(currentVehicle?.index));
            if (this.getFitmentSignature(holder, currentRow) !== signature) return;
            this.renderFitment(holder, Boolean(fits), row.parts, this.getPartsUrl(app, row), signature);
          }).catch(() => {}).finally(() => {
            if (holder.dataset.rimthinFitmentPendingSignature === signature) {
              delete holder.dataset.rimthinFitmentPendingSignature;
            }
          });
        }
      }

    });
  }
  } catch(e) { console.error(e); }
})();

})();
